<template>
  <div class="space-about">
    <property-values
      :read-only="!canEditFull"
      :properties="spacePropertiesFull"
      :value="space.properties"
      @input="updateProps"
    />
    <property-label
      :label="$t('spaceDetails.description')"
      icon="align-left"
      class="_prop -description"
      allow-overflow
    >
      <div class="_editor-content">
        <m-editor
          ref="editor"
          :initial-value="description"
          :disabled="!canEdit"
          :placeholder="$t('general.empty')"
          :allowed-content="allowedContent"
          light-placeholder
          @input="updateDescription"
        />
      </div>
    </property-label>
    <property-values
      :read-only="!canEdit"
      :properties="spacePropertiesWrite"
      :value="space.properties"
      @input="updateProps"
    />
  </div>
</template>

<script>
import MEditor from '@/components/editor/MEditor.vue';
import PropertyLabel from '@/components/PropertyLabel.vue';
import PropertyValues from '@/components/PropertyValues.vue';
import useAccess from '@/composables/access/access';
import useDebounce from '@/composables/debounce';
import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useProperties from '@/composables/property/property';
import { PROFILE } from '@/route-names';
import { accessPolicyType, editorNodeType, featureFlag } from 'shared/constants.json';

export default {
  name: 'SpaceAbout',
  props: {
    space: {
      type: Object,
      required: true,
    },
  },
  emits: ['update'],
  components: { PropertyValues, PropertyLabel, MEditor },
  setup() {
    const allowedContent = [
      editorNodeType.codeBlock,
      editorNodeType.blockquote,
      editorNodeType.bulletList,
      editorNodeType.orderedList,
    ];

    const { accountHasFeature } = useAccess();
    if (accountHasFeature([featureFlag.fileUpload])) {
      allowedContent.push(editorNodeType.image, editorNodeType.file);
    }

    const { userLang } = useLoggedInUser();
    const { spaceProperties } = useProperties();
    const { debounce } = useDebounce({ onBeforeUnmountFlush: true });
    return { userLang, spaceProperties, debounce, allowedContent };
  },
  data() {
    return { PROFILE };
  },
  computed: {
    spacePropertiesWrite() {
      return [];
    },
    spacePropertiesFull() {
      return this.spaceProperties;
    },
    description() {
      return this.space.description;
    },
    canEdit() {
      return [accessPolicyType.full, accessPolicyType.write].includes(this.space.accessRight);
    },
    canEditFull() {
      return [accessPolicyType.full].includes(this.space.accessRight);
    },
  },
  methods: {
    updateDescription(value) {
      if (JSON.stringify(value) === JSON.stringify(this.description)) {
        return;
      }

      this.debounce(() => this.update({ ...this.space, description: value }), 1500);
    },
    updateProps(properties) {
      this.update({ ...this.space, properties });
    },
    update(entity) {
      this.$emit('update', entity);
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .space-about {
    ._m-editor-content {
      padding: .6rem 1.1rem;
    }
  }

</style>
